import React from "react";

const OrderMessage = props => {
  const { recnum, financeemail } = props;
  return <div>
      <h3 style={{ marginTop: "30px" }}>
        Online order number: {recnum}
      </h3>
      <p className="text-red">
        This is NOT your invoice. Your invoice will be sent to {financeemail}{" "}
        once your order has been processed.
      </p>
    </div>;
};

export default OrderMessage;
